export const heroFragment = graphql`
  fragment HeroFragment on ContentfulPage {
    hero {
      id
      heading
      backgroundColor
      background {
        title
        description
        sizes(maxWidth: 2560) {
          ...GatsbyContentfulSizes_withWebp
        }
      }
      alignSubheroImage
      body {
        body
      }
      ctaButtons {
        id
        title
        url
      }
      submitForm {
        description {
          description
        }
        actionUrl
        formId
        u
      }
      node_locale
      videoUrl
    }
  }
`

export const pageContentFragment = graphql`
  fragment PageFragment on ContentfulPage {
    content {
      ... on ContentfulAccordion {
        items {
          id
          title
          anchor
          content {
            content
          }
          subItems {
            id
            title
            anchor
            content {
              content
            }
          }
        }
        content {
          heading
          body {
            body
          }
          backgroundColor
          textColor
          image {
            title
            file {
              url
              fileName
              contentType
            }
          }
          ctaButtons {
            title
            url
            style
          }
        }
      }
      ... on ContentfulContentGrid {
        style
        columns
        textAlign
        gridHeading
        gridItems {
          id
          heading
          subheading
          body {
            body
          }
          backgroundColor
          image {
            id
            file {
              url
            }
          }
        }
        ctaButtons {
          id
          title
          url
          style
        }
      }
      ... on ContentfulVerticalGrid {
        id
        gridItems {
          id
          heading
          subheading
          body {
            body
          }
          backgroundColor
          ctaButtons {
            title
            url
            style
          }
        }
      }
      ... on ContentfulLogoGrid {
        id
        gridType
        gridBackgroundColor
        logo {
          id
          sizes(maxWidth: 200) {
            ...GatsbyContentfulSizes
          }
        }
      }
      ... on ContentfulTimeline {
        id
        heading
        xTimeline {
          id
          sizes(maxWidth: 2400) {
            ...GatsbyContentfulSizes_withWebp
          }
        }
        yTimeline {
          id
          sizes(maxWidth: 1000) {
            ...GatsbyContentfulSizes_withWebp
          }
        }
      }
      ... on ContentfulQuote {
        id
        quote {
          id
          quote
        }
        author
        justifyQuote
      }
      ... on ContentfulContentBlock {
        id
        heading
        body {
          id
          body
        }
        image {
          title
          sizes(maxWidth: 2560) {
            ...GatsbyContentfulSizes_withWebp
          }
        }
      }
      ... on ContentfulNewsList {
        id
        heading
        moreLink
      }
      ... on ContentfulStory {
        id
        storyVariation
        textPosition
        featureImageType
        content {
          heading
          body {
            body
          }
          backgroundColor
          textColor
          image {
            title
            file {
              url
              fileName
              contentType
            }
          }
          ctaButtons {
            title
            url
            style
          }
        }
      }
      ... on ContentfulImageCarousel {
        id
        images {
          id
          title
          description
          sizes(
            maxWidth: 2240
          ) {
            base64
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            sizes
          }
        }
      }
      ... on ContentfulBanner {
        heading
        backgroundColor
        questions {
          id
          question
          url
        }
        items {
          ... on ContentfulContentBlock {
            body {
              body
            }
          }
          ... on ContentfulCtaButton {
            title
            url
            style
          }
          ... on ContentfulSubmitForm {
            description {
              description
            }
            layout
            actionUrl
            u
            formId
          }
          ... on ContentfulTimeline {
            id
            heading
            xTimeline {
              id
              sizes(maxWidth: 2400) {
                ...GatsbyContentfulSizes_withWebp
              }
            }
            yTimeline {
              id
              sizes(maxWidth: 1000) {
                ...GatsbyContentfulSizes_withWebp
              }
            }
          }
          ... on ContentfulLogoGrid {
            id
            gridType
            gridBackgroundColor
            logo {
              id
              sizes(maxWidth: 200) {
                base64
                tracedSVG
                aspectRatio
                src
                srcSet
                srcWebp
                srcSetWebp
                sizes
              }
            }
          }
        }
      }
      ... on ContentfulSkillsList {
        heading
        body {
          body
        }
        skillItems {
          id
          title
          body {
            body
          }
        }
        cta {
          title
          url
          style
        }
      }

      ... on ContentfulDualBox {
        leftPanel {
          heading
          backgroundColor
          body {
            body
          }
          ctaButtons {
            title
            url
            style
          }
        }

        rightPanel {
          heading
          backgroundColor
          body {
            body
          }
          ctaButtons {
            title
            url
            style
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/fragments.js